import { Breadcrumb } from "@redotech/arbiter/breadcrumb";
import { matchPath } from "react-router-dom";

const CATALOG_LIST_PATHS = [
  "/",
  "/products",
  "/products/:viewName",
  "/variants",
  "/consignment",
];

/**
 * Whether a path below the Catalog base URL (e.g. `/products/all`) is a
 * Catalog list page, as opposed to a product or product family detail page.
 */
export function isCatalogListPath(catalogSubpath: string): boolean {
  const path = catalogSubpath.startsWith("/")
    ? catalogSubpath
    : `/${catalogSubpath}`;
  return CATALOG_LIST_PATHS.some((pattern) => !!matchPath(pattern, path));
}

/** Keeps detail-page breadcrumbs from linking to Catalog list pages. */
export function unlinkCatalogListBreadcrumb(
  breadcrumb: Breadcrumb,
  catalogBaseUrl: string,
): Breadcrumb {
  const { url } = breadcrumb;
  if (url === null || !url.startsWith(catalogBaseUrl)) {
    return breadcrumb;
  }
  return isCatalogListPath(url.slice(catalogBaseUrl.length))
    ? { ...breadcrumb, url: null }
    : breadcrumb;
}
